import React, { Component } from 'react';
import { Utils } from '../../utils/utils';
import Sdk from 'api.digitalpages.module.sdk.api';
import './categories.css';

export default class Categories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "color": "#FFF"
    }
  }

  componentWillMount() {
    this.setSecondaryColor()
  }

  setSecondaryColor() {
    this.setState({
      "color": Utils.getCustomizationConfig("common", "tertiary_color")
    })
  }

  getStyle(active) {
    var style = {
      backgroundColor: "transparent"
    };

    if (this.props.active === active) {
      var color = this.state.color;
      style.backgroundColor = color || "#FFF";
    };

    return style;
  }

  getCustomStyle() {
    var style = {};
    if (this.props.customStyle) style = this.props.customStyle;
    return style;
  }

  getRole() {
    var roles = Sdk.Api.authorization.user.roles;

    return {
      "graduacao": roles.filter(role => role.type === "Viewer").length > 0,
      "cursos_livres": roles.filter(role => role.type === "LearningViewer").length > 0
    }
  }

  render() {
    var role = this.getRole();
    return <>
      {this.props.page === "feed" &&
        <ul role="list" className={`rdp-react-template-component-categories ${!role.graduacao ? "centered" : ""}`}>
          {/* <li className={`rdp-react-template-component-category ${this.props.active === "tendences" ? "active" : ""}`}>
            <span className="rdp-react-template-component-category-icon tendences"></span>
            <span className="rdp-react-template-component-category-label">Em alta</span>
          </li> */}
          {role.graduacao &&
            <li tabIndex="0" aria-label="Estudar" role="listitem" className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("study")}>
              <span aria-hidden="true" className="rdp-react-template-component-category-icon play"></span>
              <span aria-hidden="true" className="rdp-react-template-component-category-label">Estudar</span>
              <div aria-hidden="true" className="rdp-react-template-component-category-border" style={this.getStyle("study")}></div>
            </li>
          }
          {role.graduacao &&
            <li tabIndex="0" aria-label="Minhas Disciplinas" role="listitem" className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("courses")}>
              <span aria-hidden="true" className="rdp-react-template-component-category-icon book"></span>
              <span aria-hidden="true" className="rdp-react-template-component-category-label">Minhas Disciplinas</span>
              <div aria-hidden="true" className="rdp-react-template-component-category-border" style={this.getStyle("courses")}></div>
            </li>
          }
          {role.cursos_livres &&
            <li tabIndex="0" aria-label="Meus Cursos" role="listitem" className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("courses")}>
              <span aria-hidden="true" className="rdp-react-template-component-category-icon book"></span>
              <span aria-hidden="true" className="rdp-react-template-component-category-label">Meus Cursos</span>
              <div aria-hidden="true" className="rdp-react-template-component-category-border" style={this.getStyle("courses")}></div>
            </li>
          }
          <li tabIndex="0" aria-label="Em Alta" role="listitem" className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("em-alta")}>
            <span aria-hidden="true" className="rdp-react-template-component-category-icon tendences"></span>
            <span aria-hidden="true" className="rdp-react-template-component-category-label">Em Alta</span>
            <div aria-hidden="true" className="rdp-react-template-component-category-border" style={this.getStyle("em-alta")}></div>
          </li>
          {/* <li className="rdp-react-template-component-category">
            <span className="rdp-react-template-component-category-icon dollar"></span>
            <span className="rdp-react-template-component-category-label">Financeiro</span>
            <div className="rdp-react-template-component-category-border" style={this.getStyle("financeiro")}></div>
          </li> */}
          {role.graduacao &&
            <li tabIndex="0" aria-label="Secretaria" role="listitem" className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("secretaria")}>
              <span aria-hidden="true" className="rdp-react-template-component-category-icon monitor"></span>
              <span aria-hidden="true" className="rdp-react-template-component-category-label">Secretaria</span>
              <div aria-hidden="true" className="rdp-react-template-component-category-border" style={this.getStyle("secretaria")}></div>
            </li>
          }
          {/* <li className={`rdp-react-template-component-category ${this.props.active === "podcasts" ? "active" : ""}`}>
            <span className="rdp-react-template-component-category-icon podcasts"></span>
            <span className="rdp-react-template-component-category-label">Podcasts</span>
          </li> */}
          {/* <li className={`rdp-react-template-component-category ${this.props.active === "events" ? "active" : ""}`}>
            <span className="rdp-react-template-component-category-icon documents"></span>
            <span className="rdp-react-template-component-category-label">Documentos</span>
          </li> */}
        </ul>
      }

      {this.props.page === "dashboard" &&
        <ul className="rdp-react-template-component-categories" style={this.getCustomStyle()}>
          <li className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("meu-semestre")}>
            <span className="rdp-react-template-component-category-icon books"></span>
            <span className="rdp-react-template-component-category-label">Meu Semestre</span>
            <div className="rdp-react-template-component-category-border" style={this.getStyle("meu-semestre")}></div>
          </li>
          {/* <li className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("todos-os-semestres")}>
            <span className="rdp-react-template-component-category-icon calendar"></span>
            <span className="rdp-react-template-component-category-label">Todos os Semestres</span>
            <div className="rdp-react-template-component-category-border" style={this.getStyle("todos-os-semestres")}></div>
          </li> */}
          <li className="rdp-react-template-component-category" onClick={() => this.props.onTabClick("insights")}>
            <span className="rdp-react-template-component-category-icon calendar"></span>
            <span className="rdp-react-template-component-category-label">Insights</span>
            <div className="rdp-react-template-component-category-border" style={this.getStyle("insights")}></div>
          </li>
        </ul>
      }
    </>
  }
}
